import { CLEAR_USER_SESSION, SET_USER_SESSION } from "actions/types";
import { createReducer } from "@reduxjs/toolkit";

const initialState = {};

const userSessionReducer = createReducer(initialState, {
  [SET_USER_SESSION]: (state, action) => {
    return action.payload;
  },
  [CLEAR_USER_SESSION]: (state, action) => {
    return {};
  },
});

export default userSessionReducer;
